import { loadModules } from "esri-loader";
import { findIdFor } from "../stores/helpers";
import { difference, flatten, uniq, join, uniqBy, prop } from "ramda";

const getRasterImages = async ({
  view,
  ids,
  geometry,
  imagery,
  layers,
  type
}) => {
  if (!ids.length) return Promise.resolve([]);
  const [Query] = await loadModules(["esri/rest/support/Query"]);
  let query = new Query();
  query.outFields = ["DownloadURL", "DatasetID", "Name"];
  // query.num = layers.length;
  query.where = `NAME NOT LIKE 'Ov_%' AND DatasetID IN (${join(",", ids)})`;
  query.geometry = geometry;
  query.returnGeometry = false;
  query.spatialRelationship = "intersects";
  return imagery.queryTask
    .execute(query)
    .then(({ features }) => {
      const items = features.map(feature => ({
        id: feature.attributes.DatasetID,
        title: layers.find(l => findIdFor(l) === feature.attributes.DatasetID)
          .title,
        url: feature.attributes.DownloadURL,
        name: feature.attributes.Name,
        type,
        selected: false
      }));
      const uniqItems = uniqBy(prop("name"), items);
      return uniqItems;
    })
    .catch(error => console.log("an error occurred: ", error));
};

export const loadRasters = async ({ view, event, layers, imagery, ids }) => {
  if (ids.length > 0) {
    const [geometryEngine] = await loadModules([
      "esri/geometry/geometryEngine"
    ]);
    const filteredLayers = layers
      .filter(l => l.visible)
      .filter(layer =>
        geometryEngine.contains(layer.fullExtent, event.mapPoint)
      );
    const layerIds = uniq(flatten(filteredLayers.items.map(l => findIdFor(l))));
    const intersectedIds = difference(ids, layerIds);
    const responses = await Promise.all([
      getRasterImages({
        view,
        ids: intersectedIds,
        geometry: event.mapPoint,
        layers,
        imagery,
        type: "Available"
      }),
      getRasterImages({
        view,
        ids: layerIds,
        geometry: event.mapPoint,
        layers,
        imagery,
        type: "Visible"
      })
    ]);
    return responses;
  }
  return Promise.resolve([]);
};
